import { /*useDispatch,*/ useDispatch, useSelector } from "react-redux";
import { RdxType } from "../../data/Types";
import { CHANGE_USER_INFO, CHANGE_USER_LOGIN_TOKEN, CHANGE_USER_RESET, SystemRolesType, UserInfoType } from "../../data/redux/userReducer";
import { CHANGE_UI_LANGUAGE, CHANGE_UI_RESET, LanguageType } from "../../data/redux/uIReducer";
import { useEffect, useState } from "react";
import { useFetch, useJwt } from "../data/useFetcher";
import { Helpers } from "../../data/Helpers";
import { CHANGE_ORGANIZATION_RESET, OrganizationUserRoleType } from "../../data/redux/organizationReducer";
import Base64 from "../../data/Base64";

export const useUser = () => {
    const user: UserInfoType = useSelector((state: RdxType) => state.user?.user) as UserInfoType;
    const language = useSelector((state: RdxType) => state.ui.language);
    const currentOrganization = useSelector((state: RdxType) => state.organization?.currentOrganization);
    const dispatch = useDispatch();
    const api = useUserApi();
    const jwt = useJwt();
    const loggedIn = !!user?.id;

    const loadUser = async () => {
        let _user: UserInfoType = await api.getUser();


        // await Helpers.delay(1500);
        if (!!_user?.id) {
            const r = await api.refreshTokens();

            const decoded: TypeDecodedJwttokenType = JSON.parse(Base64.atob(r.token.split('.')[1]))

            const jwtRoles = decoded?.["https://ohgarden.se/claims/roles"];
            const jwtProducts = decoded?.["https://ohgarden.se/claims/products"];

            if (!!jwtRoles) {
                _user.roles = (Array.isArray(jwtRoles) ? jwtRoles : [jwtRoles]) as SystemRolesType[];
            } else {
                _user.roles = [];
            }
            if (!!jwtProducts) {
                _user.products = Array.isArray(jwtProducts) ? jwtProducts : [jwtProducts];
            } else {
                _user.products = [];
            }

            if (r?.success === true) {
                jwt.setJwt(r?.token);
            }
        }

        dispatch({ type: CHANGE_USER_INFO, payload: _user });
    }

    const getMyRoleinOrganization = () => {
        const orgid = currentOrganization?.id ?? "";
        return user?.organizationRoles.find(m => m.startsWith(orgid))?.split(":")?.[1] as OrganizationUserRoleType ?? "NONE";
    }

    return {
        loadUser: loadUser,
        getMyRoleinOrganization: getMyRoleinOrganization,
        logOut: async () => {
            jwt.removeJwt();
            dispatch({ type: CHANGE_USER_RESET });
            dispatch({ type: CHANGE_UI_RESET });
            dispatch({ type: CHANGE_ORGANIZATION_RESET });
        },
        loginWithToken: async (e: string) => {
            const r = await api.loginWithToken(e);
            if (r.success === true) {
                jwt.setJwt(r.token);
                await loadUser();
            } else {
                alert(r.message)
            }
        },
        loginWithCredentials: async (email?: string, pwd?: string) => {
            const r = await api.loginWithCredentials(email ?? "", pwd ?? "");
            if (r.success === true) {
                jwt.setJwt(r.token);
                await loadUser();
            } else {
                alert(r.message)
            }
        },
        createNewAccount: async (email: string) => {
            return await api.createNewAccount(email);
        },
        sendLoginlink: async (email: string) => {
            return await api.sendLoginlink(email);
        },
        createNewOrganization: async (organizationName: string) => {
            const res = await api.createNewOrganization(organizationName);
            if (res?.success === true) {
                await loadUser();
            }
            return res;
        },
        ...user,
        language: language,
        setLanguage: (e: LanguageType) => {
            dispatch({ type: CHANGE_UI_LANGUAGE, payload: e })
        },
        loggedIn: loggedIn,
        isDeveloper: !!(user?.roles?.includes("DEVELOPER")),
        isOrganizationAdministrator: !!(user?.roles?.includes("ORGANIZATIONADMINISTRATOR")),
        // loginWithToken: async (token: string) => {
        //     dispatch({ type: CHANGE_USER_LOGIN_TOKEN, payload: token })
        // },

        // isOwner: user?.roles?.indexOf("ORGANIZATION_OWNER") >= 0 || true,
        // isMember: user?.roles?.indexOf("ORGANIZATION_MEMBER") >= 0,
        // isInOrganization:
        //     user?.roles?.indexOf("ORGANIZATION_OWNER") >= 0 ||
        //     user?.roles?.indexOf("ORGANIZATION_MEMBER") >= 0,

    }
}

const useUserApi = () => {


    const f = useFetch();
    return {
        createNewAccount: async (email: string) => {
            const url = "/api/auth/createaccount/email/pro";
            const response: { success: boolean, message: string } = await f.post(url, { email: email });
            return response;
        },
        sendLoginlink: async (email: string) => {
            const url = "/api/auth/login/email/pro";
            const response: { success: boolean, message: string } = await f.post(url, { email: email });
            return response;
        },
        createNewOrganization: async (organizationName: string) => {
            const url = "/api/organization";
            const res: { success: boolean, message: string } = await f.post(url, { name: organizationName });
            return res;
        },
        getUser: async (): Promise<UserInfoType> => {
            return await f.get("/api/auth/me");
        },
        loginWithToken: async (e: string) => {
            const url = "/api/auth/login/email/" + e;
            const response: { token: string, refreshtoken: string, success: boolean, message: string } = await f.get(url);
            return response;
        },
        loginWithCredentials: async (email: string, pwd: string) => {
            const url = "/api/auth/login/credentials";
            const p = { email: email, pwd: pwd };
            const response: {
                token: string, refreshtoken: string,
                success: boolean, message: string
            } = await f.post(url, p);
            return response;
        },
        refreshTokens: async () => {
            const url = "/api/accountactions/refresh";
            const response: { token: string, success: boolean } = await f.get(url);
            return response;
        }
    }
}


export type TypeDecodedJwttokenType = {
    iss: string,
    aud: string,
    jti: string,
    sub: string,
    exp: number,
    auth_time: number,
    "https://ohgarden.se/claims/id": string,
    "https://ohgarden.se/claims/name": string,
    "https://ohgarden.se/claims/email": string,
    "https://ohgarden.se/claims/garden": string | string[],
    "https://ohgarden.se/claims/organizations": string | string[],
    "https://ohgarden.se/claims/products": string | string[],
    "https://ohgarden.se/claims/roles": string | string[],
}